module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-800@2x-3b7e0a9b078c5d3b4cc60cc949ca7f8f.jpg";